module.exports = __webpack_public_path__ + "assets/index-exchange.fa240f89.svg";